import { coalesceLocaleField } from '../helpers/coalesceLocaleField'
import { groq } from 'next-sanity'
import { LocaleId } from '@portfolio/configs'
import { createEditorialRichTextProjection } from '../projections/createEditorialRichTextProjection'
import { createMediaProjection } from '../projections/createMediaProjection'

export const createSectionSideContentWithMediaProjection = (
  localeId: LocaleId,
) => {
  const EDITORIAL_RICH_TEXT_PROJECTION =
    createEditorialRichTextProjection(localeId)
  const MEDIA_PROJECTION = createMediaProjection(localeId)

  return groq`{
        _key,
        _type,
        ${coalesceLocaleField('title', localeId)},
        spacing,
        topBorder,
        content[] {
          ${coalesceLocaleField(
            'localeEditorialRichText',
            localeId,
          )}[]${EDITORIAL_RICH_TEXT_PROJECTION},
          media${MEDIA_PROJECTION}
        },
      }
  `
}
